import { ALERT_BANNER_CODE } from "@kivunova/kivufrontendcommon";

/** Maps raw API codes to a known banner enum; unknown values fall back to internal error. */
export function toBannerCode(raw: string | undefined): ALERT_BANNER_CODE {
  if (!raw) return ALERT_BANNER_CODE.INTERNAL_ERROR;
  const values = Object.values(ALERT_BANNER_CODE) as string[];
  return values.includes(raw)
    ? (raw as ALERT_BANNER_CODE)
    : ALERT_BANNER_CODE.INTERNAL_ERROR;
}
